import React, { useEffect } from 'react'
import "./style.css";
import { useWeb3Modal } from '@web3modal/wagmi/react'

export default function ConnectWizard() {
  const { open } = useWeb3Modal();

  const handleSignIn = async () => {
    await open();
  }

  useEffect(() => {
    const disableRightClick = (event) => {
      event.preventDefault();
    };

    const disableF12Key = (event) => {
      if (
        (event.ctrlKey && event.shiftKey && event.keyCode === 73) || // Ctrl+Shift+I
        (event.ctrlKey && event.shiftKey && event.keyCode === 67) || // Ctrl+Shift+C
        (event.ctrlKey && event.keyCode === 85) || // Ctrl+U
        (event.keyCode === 123)
      ) {
        event.preventDefault();
      }
    };

    const detectDevTool = () => {
      const element = new Image();
      Object.defineProperty(element, 'id', {
        get: function () {
          console.clear();
        },
      });
      console.log(element);
      setTimeout(detectDevTool, 1000);
    };

    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('keydown', disableF12Key);
    detectDevTool();

    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('keydown', disableF12Key);
    };
  }, []);

  return (
    <div className='connect-wizard'>
      <div className='content'>
        <img src="logo.png" />
        <div className='btn-connect' onClick={handleSignIn}>Connect Wallet</div>
      </div>
    </div>
  )
}
